/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HPLC Method Transfer Calculator`)
};

const es_hplc_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Transferencia de Métodos HPLC`)
};

const de_hplc_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HPLC-Methodentransfer-Rechner`)
};

const nl_hplc_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HPLC-methodetransfercalculator`)
};

const fr_hplc_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de transfert de méthode HPLC`)
};

const it_hplc_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore trasferimento metodo HPLC`)
};

const pt_br2_hplc_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Transferência de Método de HPLC`)
};

const pt_hplc_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Transferência de Método de HPLC`)
};

const ja_hplc_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HPLCメソッド移行計算機`)
};

const zh_hplc_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HPLC 方法转移计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_h1", locale)
	if (locale === "en") return en_hplc_h1(inputs)
	if (locale === "es") return es_hplc_h1(inputs)
	if (locale === "de") return de_hplc_h1(inputs)
	if (locale === "nl") return nl_hplc_h1(inputs)
	if (locale === "fr") return fr_hplc_h1(inputs)
	if (locale === "it") return it_hplc_h1(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_h1(inputs)
	if (locale === "pt") return pt_hplc_h1(inputs)
	if (locale === "ja") return ja_hplc_h1(inputs)
	return zh_hplc_h1(inputs)
};